export const FETCHING = "PRECAMPAIGN/FETCHING"
export const RESET = "PRECAMPAIGN/RESET"
export const SUCCESS = "PRECAMPAIGN/SUCESS"
export const ERROR = "PRECAMPAIGN/ERROR"
export const SEARCH_DONATION = "SEARCH_DONATION"
